import { render, staticRenderFns } from "./AssistantNotificationSettingDialog.vue?vue&type=template&id=19e26a26&scoped=true"
import script from "./AssistantNotificationSettingDialog.vue?vue&type=script&lang=js"
export * from "./AssistantNotificationSettingDialog.vue?vue&type=script&lang=js"
import style0 from "./AssistantNotificationSettingDialog.vue?vue&type=style&index=0&id=19e26a26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e26a26",
  null
  
)

export default component.exports